export default __webpack_public_path__ + "static/media/p4.13f4596b.gif";